<template>
  <button class="viewer-btn" :class="[`viewer-btn-${variant}`, `size-${size}`, { border: !borderless }]" @click="$emit('click')">
    <slot />
  </button>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  variant: {
    type: String,
    default: 'light',
  },
  size: {
    type: String as PropType<'md' | 'lg' | 'xl'>,
    default: 'md',
  },
  borderless: {
    type: [Boolean, String],
    default: false,
  },
})

defineEmits(['click'])
</script>

<style lang="stylus" scoped>
.viewer-btn
  @apply appearance-none flex flex-col justify-center items-center gap-4 h-32 rounded-lg font-normal text-sm px-4 hover_border hover_bg-copper-200 hover_bg-opacity-30 focus_border focus_bg-copper-200 focus_bg-opacity-30
  &-light
    @apply bg-gray-200 bg-opacity-20 border-copper-200
  &-dark
    @apply bg-gray-900
  &-transparent
    @apply gap-3 bg-transparent border border-gray-300 rounded-md bg-white shadow-sm transition-colors hover_bg-transparent hover_border-gray-500 focus_bg-transparent

.size-md
  @apply w-36
.size-lg
  width 11rem
.size-xl
  @apply w-58 h-34
</style>
